/**
 * Created by swandelow on 19/09/18.
 */
import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from "@angular/core";
import {SaraSelectComponent} from "../../../shared/sara-select/sara-select.component";
import {RestrictionsService} from "../restrictions.service";
import {RentalLength} from "./rental-length";

@Component({
    selector: "rental-length-settings",
    templateUrl: "./rental-length-settings.component.html"
})
export class RentalLengthSettingsComponent implements OnInit {

    @Input() min: number;
    @Input() max: number;
    @Input() errors: any;

    @ViewChild("maxRentalLength")
    maxSelect: SaraSelectComponent;

    @Output() rentalLengthChange = new EventEmitter<RentalLength>();
    selectMinDurationList: any[];

    selectMaxDurationList: any[];

    constructor(private restrictionsService: RestrictionsService) {
    }

    ngOnInit(): void {
        this.selectMinDurationList = this.restrictionsService.getMinDurationList();
        this.selectMaxDurationList = this.restrictionsService.getMaxDurationList(this.min);
    }

    onMinSelected() {
        let currentMax = this.max;
        if (this.min >= this.max) {
            this.selectMaxDurationList = this.restrictionsService.getMaxDurationList(this.min);
            this.max = this.min + 1;
            this.maxSelect.model = this.max;
        } else {
            this.selectMaxDurationList = this.restrictionsService.getMaxDurationList(this.min);
            this.maxSelect.model = currentMax;
        }
        this.emitRentalLength();
    }

    onMaxSelected() {
        this.emitRentalLength();
    }

    private emitRentalLength() {
        this.rentalLengthChange.emit({min: this.min, max: this.max});
    }


}


// WEBPACK FOOTER //
// ./public/upgrade/feature/restrictions/rental-length-settings/rental-length-settings.component.ts